export default "__VITE_ASSET__BLGgVYlH__"